// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"80f2d220","590":"d9b0d97c"}[chunkId] + ".chunk.js";
};